import { render, staticRenderFns } from "./UserRuleCreator.vue?vue&type=template&id=49356dae&scoped=true"
import script from "./UserRuleCreator.vue?vue&type=script&lang=js"
export * from "./UserRuleCreator.vue?vue&type=script&lang=js"
import style0 from "./UserRuleCreator.vue?vue&type=style&index=0&id=49356dae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49356dae",
  null
  
)

export default component.exports